(function () {
  const seq = (from, to, step) => {
    const out = [];
    for (let n = from; n <= to + 1e-9; n = +(n + step).toFixed(4)) out.push(n);
    return out;
  };
  const pad2 = (n) => {
    const [a, b = ""] = String(n).split(".");
    return a + "." + (b + "00").slice(0, 2);
  };
  const signed = (from, to, step) =>
    seq(from, to, step).map((n) => (n === 0 ? "0.00" : (n > 0 ? "+" : "") + pad2(n)));
  const insertAfter = (list, target, extra) => {
    const next = [...list];
    const index = next.indexOf(target);
    next.splice(index + 1, 0, extra);
    return next;
  };
  const emailOk = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || "").trim());
  const API_PREFIX = "/apps/online/resource/rayneo/prescription";
  const TYPE_MAP = {
    single: "SINGLE_VISION",
    progressive: "PROGRESSIVE",
    reading: "READING_GLASSES_READERS",
    rxreading: "READING_GLASSES_PRESCRIPTION_READING",
  };
  const TYPE_ALIASES = {
    INGLE_VISION: "SINGLE_VISION",
    READDING_GLASSES_READERS: "READING_GLASSES_READERS",
    READDING_GLASSES_PRESCRIPTION_READING: "READING_GLASSES_PRESCRIPTION_READING",
  };
  const canonicalType = (code) => {
    const value = String(code || "").trim();
    return TYPE_ALIASES[value] || value;
  };

  function saRxFactory() {
    return {
      step: "gate",
      unlocked: false,
      accessKey: "",
      accessErr: false,
      type: "progressive",
      learnOpen: false,
      prismHelpOpen: false,
      dualPd: false,
      prism: false,
      pdTouched: false,
      addTouched: false,
      prismTouched: false,
      triedSubmit: false,
      unionOpen: false,
      powerAck: false,
      isMobile: false,
      picker: { open: false, field: "", title: "", options: [], temp: "" },
      mag: "",
      od_sph: "0.00",
      os_sph: "0.00",
      od_cyl: "0.00",
      os_cyl: "0.00",
      od_axis: "None",
      os_axis: "None",
      od_add: "0.00",
      os_add: "0.00",
      pd: "",
      pd_r: "",
      pd_l: "",
      od_pv: "0.00",
      od_bd: "",
      od_pv_r: "0.00",
      od_bd_r: "",
      os_pv: "0.00",
      os_bd: "",
      os_pv_r: "0.00",
      os_bd_r: "",
      invoice_id: "",
      first_name: "",
      last_name: "",
      phone: "",
      email: "",
      purchase_channel: "",
      country: "",
      province: "",
      city: "",
      address: "",
      zip: "",
      shipTried: false,
      submitBusy: false,
      submitErr: "",
      pending: null,
      lastOrder: null,
      cfg: {},
      t: {},
      tokens: { pl: "PL", sphDs: "SPH/DS", axisNone: "None" },
      channels: [],
      types: [],
      horizBdOpts: ["In", "Out"],
      vertBdOpts: ["Up", "Down"],

      init() {
        const node = this.$root.querySelector("[data-sa-rx-config]");
        let cfg = {};
        try {
          cfg = node ? JSON.parse(node.textContent) : {};
        } catch (err) {
          cfg = {};
        }
        this.cfg = cfg || {};
        this.t = this.cfg.t || {};
        this.tokens = Object.assign({ pl: "PL", sphDs: "SPH/DS", axisNone: "None" }, this.cfg.tokens || {});
        this.channels = this.cfg.channels || [];
        this.types = this.cfg.types || [];
        this.od_axis = this.tokens.axisNone;
        this.os_axis = this.tokens.axisNone;

        const mq = window.matchMedia("(max-width: 720px)");
        this.isMobile = mq.matches;
        mq.addEventListener("change", (e) => {
          this.isMobile = e.matches;
          if (!e.matches && this.picker.open) this.closePicker(false);
        });

        const params = new URLSearchParams(location.search);
        const key = params.get("key") || "";
        const storageKey = this.cfg.storageKey || "rayneo_key";
        const access = this.expectedAccess();
        let saved = "";
        try {
          saved = sessionStorage.getItem(storageKey) || "";
        } catch (err) {
          saved = "";
        }
        if (access && (key === access || saved === access)) {
          this.unlocked = true;
          this.step = "type";
          if (key === access) {
            try {
              sessionStorage.setItem(storageKey, access);
            } catch (err) {}
          }
        } else {
          this.unlocked = false;
          this.step = "gate";
        }
      },

      get pdMin() {
        return Number(this.cfg.pdMin) || 54;
      },
      get pdMax() {
        return Number(this.cfg.pdMax) || 78;
      },
      get typeTitle() {
        const hit = (this.types || []).find((item) => item.id === this.type);
        return hit ? hit.title : "";
      },
      get showAdd() {
        return this.type === "progressive" || this.type === "rxreading";
      },
      get magOpts() {
        return signed(0.25, 6, 0.25);
      },
      get sphOpts() {
        const min = this.type === "progressive" ? -18 : -20;
        return insertAfter(signed(min, 10, 0.25), "0.00", this.tokens.pl);
      },
      get cylOpts() {
        return insertAfter(signed(-6, 6, 0.25), "0.00", this.tokens.sphDs);
      },
      get axisOpts() {
        return [this.tokens.axisNone, ...seq(1, 180, 1).map(String)];
      },
      get addOpts() {
        const list = signed(this.type === "progressive" ? 0.5 : 0, 3.5, 0.25);
        return this.type === "progressive" ? ["0.00", ...list] : list;
      },
      get pdOpts() {
        return seq(this.pdMin, this.pdMax, 0.5).map((n) => n.toFixed(1));
      },
      get halfPdOpts() {
        const lo = this.pdMin % 2 === 0 ? this.pdMin / 2 - 2 : this.pdMin / 2 - 2.5;
        const hi = this.pdMax % 2 === 0 ? this.pdMax / 2 + 2 : this.pdMax / 2 + 2.5;
        return seq(lo, hi, 0.5).map((n) => n.toFixed(1));
      },
      get prismOpts() {
        return ["0.00", ...seq(0.5, 5, 0.25).map((n) => n.toFixed(2))];
      },

      sphNum(v) {
        if (!v || v === this.tokens.pl) return 0;
        return parseFloat(v);
      },
      cylNum(v) {
        if (!v || v === this.tokens.sphDs) return 0;
        return parseFloat(v);
      },
      hasCyl(v) {
        return !!(v && v !== "0.00" && v !== this.tokens.sphDs);
      },
      bdOff(pv) {
        return !pv || pv === "0.00";
      },
      bdErr(pv, bd) {
        return !this.bdOff(pv) && !bd;
      },
      bdPair(pvField) {
        return pvField.replace("_pv", "_bd");
      },
      onPvChange(pvField) {
        this.prismTouched = true;
        if (this.bdOff(this[pvField])) this[this.bdPair(pvField)] = "";
      },
      odAxisOff() {
        return !this.hasCyl(this.od_cyl);
      },
      osAxisOff() {
        return !this.hasCyl(this.os_cyl);
      },
      pickTitle(col, eye) {
        return [col, eye].filter(Boolean).join(" ");
      },
      shown(value, placeholder) {
        return value || placeholder || "";
      },
      optLabel(opt) {
        const t = this.t || {};
        if (opt === "In") return t.baseIn || opt;
        if (opt === "Out") return t.baseOut || opt;
        if (opt === "Up") return t.baseUp || opt;
        if (opt === "Down") return t.baseDown || opt;
        return opt;
      },
      shownBd(value) {
        if (!value) return this.t.select || "";
        return this.optLabel(value);
      },

      get result() {
        const flags = { odAxis: false, osAxis: false };
        const odSph = this.sphNum(this.od_sph);
        const osSph = this.sphNum(this.os_sph);
        let sph = 0;
        if (odSph < 0 !== osSph < 0 && odSph !== 0 && osSph !== 0) sph = 1;
        else if (Math.abs(odSph - osSph) >= 3) sph = 2;

        const odCyl = this.cylNum(this.od_cyl);
        const osCyl = this.cylNum(this.os_cyl);
        let cyl = 0;
        if (odCyl < 0 !== osCyl < 0 && odCyl !== 0 && osCyl !== 0) cyl = 1;
        else if (Math.abs(odCyl - osCyl) >= 3) cyl = 2;

        const none = this.tokens.axisNone;
        const odOk = !this.hasCyl(this.od_cyl) || this.od_axis !== none;
        const osOk = !this.hasCyl(this.os_cyl) || this.os_axis !== none;
        flags.odAxis = !odOk;
        flags.osAxis = !osOk;
        const axis = !odOk || !osOk ? 1 : 0;

        let add = 0;
        if (this.type === "progressive") {
          if ((!this.od_add || this.od_add === "0.00") && (!this.os_add || this.os_add === "0.00")) add = 1;
          else if (this.od_add !== this.os_add) add = 2;
        }

        let pd = 0;
        if (this.type !== "reading") {
          if (this.dualPd) {
            if (!this.pd_l || !this.pd_r) pd = 1;
            else {
              const sum = Number(this.pd_l) + Number(this.pd_r);
              const diff = Math.abs(Number(this.pd_l) - Number(this.pd_r));
              if (sum < this.pdMin) pd = 3;
              else if (sum > this.pdMax) pd = 2;
              else if (diff >= 5) pd = 4;
            }
          } else if (!this.pd) pd = 1;
          else if (Number(this.pd) > this.pdMax) pd = 2;
          else if (Number(this.pd) < this.pdMin) pd = 3;
        }

        let prism = 0;
        if (this.prism) {
          const keys = ["od_pv", "os_pv", "od_pv_r", "os_pv_r"];
          const allEmpty = keys.every((k) => this[k] === "0.00" && !this[k.replace("pv", "bd")]);
          const mismatch = keys.some((k) => {
            const pv = this[k];
            const bd = this[k.replace("pv", "bd")];
            return (pv === "0.00" && bd) || (pv !== "0.00" && !bd);
          });
          if (allEmpty) prism = 1;
          else if (mismatch) prism = 2;
        }

        const odPower = odSph + odCyl;
        const osPower = osSph + osCyl;
        let powerOk = true;
        if (this.type === "progressive" && (odPower < -18 || osPower < -18)) powerOk = false;
        if ((this.type === "single" || this.type === "rxreading") && (odPower < -20 || osPower < -20)) powerOk = false;

        return {
          sph,
          cyl,
          axis,
          add: this.addTouched || this.triedSubmit ? add : 0,
          pd: this.pdTouched || this.triedSubmit || pd > 1 ? pd : 0,
          prism: this.prismTouched || this.triedSubmit ? prism : 0,
          flags,
          powerOk,
          addRaw: add,
          pdRaw: pd,
          prismRaw: prism,
        };
      },
      sphMsg(code) {
        return ["", this.t.sphDifferent, this.t.sphAbnormal][code] || "";
      },
      cylMsg(code) {
        return ["", this.t.cylDifferent, this.t.cylAbnormal][code] || "";
      },
      addMsg(code) {
        return ["", this.t.addNotZero, this.t.addMustBeSame][code] || "";
      },
      get tableMsg() {
        const r = this.result;
        if (r.axis) return this.t.axisRequired || "";
        if (r.add) return this.addMsg(r.add);
        if (r.sph) return this.sphMsg(r.sph);
        if (r.cyl) return this.cylMsg(r.cyl);
        return "";
      },
      get mobileTableMsg() {
        const r = this.result;
        if (r.axis) return this.t.axisRequired || "";
        if (r.add) return "";
        if (r.sph) return this.sphMsg(r.sph);
        if (r.cyl) return this.cylMsg(r.cyl);
        return "";
      },
      get mobileAddMsg() {
        const r = this.result;
        return r.axis ? "" : this.addMsg(r.add);
      },
      get pdMsgs() {
        const r = this.result;
        return [["", this.t.pdRequired, this.t.pdTooBig, this.t.pdTooSmall, this.t.pdDiff][r.pd]].filter(Boolean);
      },
      get prismMsgs() {
        const r = this.result;
        return [["", this.t.prismOne, this.t.prismPair][r.prism]].filter(Boolean);
      },
      splitPds() {
        if (this.dualPd) return { right: this.pd_r || "", left: this.pd_l || "" };
        if (!this.pd) return { right: "", left: "" };
        const n = Number(this.pd);
        if (!Number.isFinite(n)) return { right: this.pd, left: this.pd };
        const half = (n / 2).toFixed(1);
        return { right: half, left: half };
      },
      emptyPrism(v) {
        return !this.prism || !v || v === "0.00" ? "" : v;
      },
      bdDb(pv, bd) {
        return this.prism && !this.bdOff(pv) && bd ? String(bd).toUpperCase() : "";
      },
      get orderPayload() {
        const pds = this.splitPds();
        const none = this.tokens.axisNone;
        const addRight = this.showAdd && this.od_add && this.od_add !== "0.00" ? this.od_add : "";
        const addLeft = this.showAdd && this.os_add && this.os_add !== "0.00" ? this.os_add : "";
        const saved = this.cfg.typeCodes || {};
        const typeMap = {
          single: canonicalType(saved.single || TYPE_MAP.single),
          progressive: canonicalType(saved.progressive || TYPE_MAP.progressive),
          reading: canonicalType(saved.reading || TYPE_MAP.reading),
          rxreading: canonicalType(saved.rxreading || TYPE_MAP.rxreading),
        };
        return {
          invoice_id: this.invoice_id.trim(),
          first_name: this.first_name.trim(),
          last_name: this.last_name.trim(),
          phone: this.phone.trim(),
          email: this.email.trim(),
          purchase_channel: this.purchase_channel,
          province: this.province.trim(),
          country: this.country.trim(),
          city: this.city.trim(),
          address: this.address.trim(),
          zip: this.zip.trim(),
          prescription_type: typeMap[this.type] || this.type,
          readers_magnification_strength: this.type === "reading" ? this.mag : "",
          right_sph: this.od_sph,
          right_cyl: this.od_cyl,
          right_axis: this.od_axis === none ? "" : this.od_axis,
          right_add: addRight,
          riight_add: addRight,
          left_sph: this.os_sph,
          left_cyl: this.os_cyl,
          left_axis: this.os_axis === none ? "" : this.os_axis,
          left_add: addLeft,
          right_pd: pds.right,
          left_pd: pds.left,
          right_prism_horizontal: this.emptyPrism(this.od_pv),
          right_prism_horizontal_base_direction: this.bdDb(this.od_pv, this.od_bd),
          right_prism_vertical: this.emptyPrism(this.od_pv_r),
          right_prism_vertical_base_direction: this.bdDb(this.od_pv_r, this.od_bd_r),
          left_prism_horizontal: this.emptyPrism(this.os_pv),
          left_prism_horizontal_base_direction: this.bdDb(this.os_pv, this.os_bd),
          left_prism_vertical: this.emptyPrism(this.os_pv_r),
          left_prism_vertical_base_direction: this.bdDb(this.os_pv_r, this.os_bd_r),
        };
      },
      get shipErrs() {
        const t = this.t || {};
        const e = {};
        if (!this.invoice_id.trim()) e.invoice_id = t.errInvoice || "";
        if (!this.first_name.trim()) e.first_name = t.errFirst || "";
        if (!this.last_name.trim()) e.last_name = t.errLast || "";
        if (!this.phone.trim()) e.phone = t.errPhone || "";
        if (!this.email.trim()) e.email = t.errEmail || "";
        else if (!emailOk(this.email)) e.email = t.errEmailInvalid || "";
        if (!this.purchase_channel) e.purchase_channel = t.errChannel || "";
        if (!this.country.trim()) e.country = t.errCountry || "";
        if (!this.province.trim()) e.province = t.errProvince || "";
        if (!this.city.trim()) e.city = t.errCity || "";
        if (!this.address.trim()) e.address = t.errAddress || "";
        if (!this.zip.trim()) e.zip = t.errZip || "";
        return e;
      },
      shipMsg(key) {
        return this.shipTried ? this.shipErrs[key] || "" : "";
      },
      expectedAccess() {
        const root = this.$root;
        const fromDom = root && root.getAttribute("data-access-key");
        if (fromDom != null && String(fromDom).trim() !== "") return String(fromDom).trim();
        const node = root && root.querySelector("[data-sa-rx-config]");
        if (node) {
          try {
            const cfg = JSON.parse(node.textContent);
            if (cfg && cfg.accessKey != null && String(cfg.accessKey).trim() !== "") return String(cfg.accessKey).trim();
          } catch (err) {}
        }
        return "";
      },
      unlock() {
        this.accessErr = false;
        const access = this.expectedAccess();
        if (!access || this.accessKey.trim() !== access) {
          this.accessErr = true;
          return;
        }
        try {
          sessionStorage.setItem(this.cfg.storageKey || "rayneo_key", access);
        } catch (err) {}
        this.unlocked = true;
        this.step = "type";
      },
      resetRx() {
        const none = this.tokens.axisNone;
        this.mag = "";
        this.od_sph = "0.00";
        this.os_sph = "0.00";
        this.od_cyl = "0.00";
        this.os_cyl = "0.00";
        this.od_axis = none;
        this.os_axis = none;
        this.od_add = "0.00";
        this.os_add = "0.00";
        this.pd = "";
        this.pd_r = "";
        this.pd_l = "";
        this.dualPd = false;
        this.prism = false;
        this.pdTouched = false;
        this.addTouched = false;
        this.prismTouched = false;
        this.triedSubmit = false;
        this.unionOpen = false;
        this.powerAck = false;
        this.od_pv = "0.00";
        this.od_bd = "";
        this.od_pv_r = "0.00";
        this.od_bd_r = "";
        this.os_pv = "0.00";
        this.os_bd = "";
        this.os_pv_r = "0.00";
        this.os_bd_r = "";
      },
      sphClass(v) {
        const n = this.sphNum(v);
        if (!v || v === this.tokens.pl || n === 0) return "sa-rx__num";
        return "sa-rx__num is-purple";
      },
      axisClass(v) {
        return v === this.tokens.axisNone ? "sa-rx__num is-muted" : "sa-rx__num";
      },
      addCell(v) {
        if (!this.showAdd || !v || v === "0.00") return this.t.dash || "-";
        return v;
      },
      prismVal(v) {
        return !v || v === "0.00" ? this.t.dash || "-" : v;
      },
      prismBd(v) {
        return v ? this.optLabel(v) : this.t.dash || "-";
      },
      pdCell() {
        const blank = this.t.blank || "—";
        if (this.dualPd) {
          const r = this.pd_r ? Number(this.pd_r).toFixed(2) : blank;
          const l = this.pd_l ? Number(this.pd_l).toFixed(2) : blank;
          return r + " / " + l;
        }
        if (!this.pd) return blank;
        const n = Number(this.pd);
        return Number.isFinite(n) ? n.toFixed(2) : this.pd;
      },
      goBack() {
        if (this.step === "done") {
          this.step = "receipt";
          return;
        }
        if (this.step === "receipt") {
          this.step = "ship";
          return;
        }
        if (this.step === "ship") {
          this.step = this.type === "reading" ? "magnify" : "form";
          return;
        }
        if (this.step === "form" || this.step === "magnify") {
          this.step = "type";
          return;
        }
        this.step = "type";
      },
      closeFlow() {
        if (this.step === "done") this.startOver();
        else this.step = "type";
      },
      openForm(type) {
        this.type = type;
        this.resetRx();
        this.step = type === "reading" ? "magnify" : "form";
      },
      pickMag(opt) {
        const none = this.tokens.axisNone;
        this.mag = opt;
        this.od_sph = opt;
        this.os_sph = opt;
        this.od_cyl = "0.00";
        this.os_cyl = "0.00";
        this.od_axis = none;
        this.os_axis = none;
        this.od_add = "0.00";
        this.os_add = "0.00";
        this.step = "ship";
      },
      onCylChange(eye) {
        if (!this.hasCyl(this[eye + "_cyl"])) this[eye + "_axis"] = this.tokens.axisNone;
      },
      onAddChange(eye) {
        this.addTouched = true;
        if (this.type !== "progressive") return;
        if (eye === "od") this.os_add = this.od_add;
        else this.od_add = this.os_add;
      },
      onPrismToggle() {
        this.prismTouched = false;
        if (this.prism) return;
        this.od_pv = "0.00";
        this.od_bd = "";
        this.od_pv_r = "0.00";
        this.od_bd_r = "";
        this.os_pv = "0.00";
        this.os_bd = "";
        this.os_pv_r = "0.00";
        this.os_bd_r = "";
      },
      onDualPdToggle() {
        this.pd = "";
        this.pd_r = "";
        this.pd_l = "";
        this.pdTouched = true;
      },
      openPicker(field, title, options) {
        if (field.includes("_bd") && this.bdOff(this[field.replace("_bd", "_pv")])) return;
        const current = this[field];
        let fallback = options[0] || "";
        if (options.includes("0.00")) fallback = "0.00";
        else if (options.includes("63.0")) fallback = "63.0";
        this.picker = {
          open: true,
          field,
          title,
          options: [...options],
          temp: current && options.includes(current) ? current : fallback,
        };
        document.body.style.overflow = "hidden";
        this.$nextTick(() => {
          this.$nextTick(() => {
            requestAnimationFrame(() => {
              const wheel = this.$refs.wheel;
              if (!wheel) return;
              const i = Math.max(0, this.picker.options.indexOf(this.picker.temp));
              wheel.scrollTop = i * 44;
            });
          });
        });
      },
      onWheelScroll() {
        if (!this.$refs.wheel) return;
        const i = Math.round(this.$refs.wheel.scrollTop / 44);
        const clamped = Math.min(this.picker.options.length - 1, Math.max(0, i));
        this.picker.temp = this.picker.options[clamped];
      },
      closePicker(save) {
        if (save) {
          this[this.picker.field] = this.picker.temp;
          if (this.picker.field.endsWith("_cyl")) this.onCylChange(this.picker.field.slice(0, 2));
          if (this.picker.field.endsWith("_add")) this.onAddChange(this.picker.field.slice(0, 2));
          if (this.picker.field.startsWith("pd")) this.pdTouched = true;
          if (this.picker.field.includes("_pv") || this.picker.field.includes("_bd")) this.prismTouched = true;
          if (this.picker.field.includes("_pv")) this.onPvChange(this.picker.field);
        }
        this.picker.open = false;
        document.body.style.overflow = "";
      },
      confirm() {
        this.triedSubmit = true;
        this.addTouched = true;
        this.pdTouched = true;
        if (this.prism) this.prismTouched = true;
        const r = this.result;
        if (r.axis || r.addRaw || r.pdRaw || r.prismRaw) return;
        if (!r.powerOk && !this.powerAck) {
          this.unionOpen = true;
          return;
        }
        this.step = "ship";
      },
      continueShip() {
        this.shipTried = true;
        if (Object.keys(this.shipErrs).length) return;
        this.step = "receipt";
      },
      csvEscape(v) {
        const s = v == null ? "" : String(v);
        return /[",\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
      },
      downloadCsv(row) {
        const keys = Object.keys(row);
        const head = keys.join(",");
        const body = keys.map((k) => this.csvEscape(row[k])).join(",");
        const blob = new Blob([head + "\n" + body], { type: "text/csv;charset=utf-8" });
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = (row.invoice_id || this.cfg.csvName || "rayneo-order") + ".csv";
        a.click();
        URL.revokeObjectURL(a.href);
      },
      onStorefront() {
        return location.protocol !== "file:" && !/^(localhost|127\.0\.0\.1)$/.test(location.hostname);
      },
      explainError(err) {
        const code = err && err.errorCode;
        const t = this.t || {};
        if (code === "APP_PROXY_SIGNATURE_INVALID") return "APP_PROXY_SIGNATURE_INVALID. Open this page on the storefront. The lab rejects calls that Shopify did not sign.";
        if (code === "APP_PROXY_TIMESTAMP_EXPIRED") return "The store proxy timestamp expired. Submit again from this page.";
        if (code === "CUSTOMER_NOT_LOGGED_IN") return "Sign in to the store, then submit again.";
        if (code === "CUSTOMER_NOT_AUTHORIZED") return "This customer is not allowed to submit. Ask an admin to enable prescription submit.";
        if (code === "SHOPIFY_APP_NOT_ACTIVE") return "The app is not active for this shop. Reinstall or run store init.";
        if (code === "SUBMIT_TOKEN_INVALID") return "Submit token was rejected. Submit again to exchange a new token.";
        if (code === "IDEMPOTENCY_PAYLOAD_CONFLICT") return "This request ID was already used with different details. Do not change the pending order.";
        if (code === "RATE_LIMITED") return "Too many requests. Wait " + (err.retryAfter || "60") + " seconds, then submit again.";
        if (code === "SHOPIFY_AUTHORIZATION_UNAVAILABLE") return "Store authorization check failed. Wait " + (err.retryAfter || "5") + " seconds, then submit again.";
        if (code === "SECURITY_SERVICE_UNAVAILABLE") return "Security service is unavailable. Keep this order and submit again later.";
        if (code === "INVALID_REQUEST") return err.message || "Check the form and submit again.";
        return (err && err.message) || t.errSubmit || "Submit failed. Please try again.";
      },
      toApiPayload(row) {
        const omitEmpty = (v) => (v == null || v === "" ? undefined : v);
        return {
          invoiceId: row.invoice_id,
          firstName: row.first_name,
          lastName: row.last_name,
          phone: row.phone,
          email: row.email,
          purchaseChannel: row.purchase_channel,
          province: row.province,
          country: row.country,
          city: row.city,
          address: row.address,
          zip: row.zip,
          prescriptionType: row.prescription_type,
          readersMagnificationStrength: omitEmpty(row.readers_magnification_strength),
          rightSph: row.right_sph,
          rightCyl: row.right_cyl,
          rightAxis: omitEmpty(row.right_axis),
          rightAdd: omitEmpty(row.right_add),
          leftSph: row.left_sph,
          leftCyl: row.left_cyl,
          leftAxis: omitEmpty(row.left_axis),
          leftAdd: omitEmpty(row.left_add),
          rightPd: row.right_pd,
          leftPd: row.left_pd,
          rightPrismHorizontal: omitEmpty(row.right_prism_horizontal),
          rightPrismHorizontalBaseDirection: omitEmpty(row.right_prism_horizontal_base_direction),
          rightPrismVertical: omitEmpty(row.right_prism_vertical),
          rightPrismVerticalBaseDirection: omitEmpty(row.right_prism_vertical_base_direction),
          leftPrismHorizontal: omitEmpty(row.left_prism_horizontal),
          leftPrismHorizontalBaseDirection: omitEmpty(row.left_prism_horizontal_base_direction),
          leftPrismVertical: omitEmpty(row.left_prism_vertical),
          leftPrismVerticalBaseDirection: omitEmpty(row.left_prism_vertical_base_direction),
        };
      },
      fill(template, status) {
        return String(template || "").replace("{status}", String(status));
      },
      async apiPost(path, body) {
        const t = this.t || {};
        let res;
        try {
          res = await fetch(API_PREFIX + path, {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify(body),
          });
        } catch (err) {
          const error = new Error(t.errNetwork || "Network error. The result is unknown. Submit again without changing this order.");
          error.errorCode = "NETWORK";
          throw error;
        }
        const raw = await res.text();
        if (raw && raw.indexOf("APP_PROXY_SIGNATURE_INVALID") !== -1 && raw.charAt(0) !== "{") {
          const error = new Error("APP_PROXY_SIGNATURE_INVALID");
          error.errorCode = "APP_PROXY_SIGNATURE_INVALID";
          error.status = res.status;
          throw error;
        }
        let json = null;
        try {
          json = raw ? JSON.parse(raw) : null;
        } catch (err) {
          json = null;
        }
        if (!json || typeof json !== "object") {
          const error = new Error(res.ok ? t.errEmpty || "Empty response from server." : this.fill(t.errRequest, res.status));
          error.status = res.status;
          throw error;
        }
        if (!res.ok || json.code !== 200) {
          const detail = json.msg || json.message || json.error || t.errFailed || "Request failed.";
          const error = new Error(typeof detail === "string" ? detail : t.errFailed || "Request failed.");
          error.errorCode = json.errorCode || "";
          error.status = res.status;
          error.retryAfter = res.headers.get("Retry-After");
          throw error;
        }
        return json.data;
      },
      async submitOrder() {
        if (this.submitBusy) return;
        this.submitBusy = true;
        this.submitErr = "";
        if (!this.onStorefront()) {
          this.submitErr = "Open this page on the Shopify store. A local preview cannot pass the app proxy signature check.";
          this.submitBusy = false;
          return;
        }
        const payload = Object.assign({}, this.orderPayload);
        if (!this.pending) {
          this.pending = {
            requestId: crypto.randomUUID(),
            form: this.toApiPayload(payload),
          };
        }
        try {
          let data = null;
          for (let attempt = 0; attempt < 2; attempt++) {
            const exchanged = await this.apiPost("/token/exchange", { requestId: this.pending.requestId });
            const submitToken = exchanged && exchanged.submitToken;
            if (!submitToken) throw new Error(this.t.errNoToken || "No submit token returned.");
            try {
              data = await this.apiPost("/submit", Object.assign({}, this.pending.form, {
                requestId: this.pending.requestId,
                submitToken: submitToken,
              }));
              break;
            } catch (error) {
              if (error.errorCode === "SUBMIT_TOKEN_INVALID" && attempt === 0) continue;
              throw error;
            }
          }
          const extra = data && typeof data === "object" ? data : {};
          this.lastOrder = Object.assign({}, payload, extra);
          this.pending = null;
          this.step = "done";
        } catch (err) {
          if (err && err.errorCode === "INVALID_REQUEST") this.pending = null;
          this.submitErr = this.explainError(err);
        } finally {
          this.submitBusy = false;
        }
      },
      startOver() {
        this.resetRx();
        this.invoice_id = "";
        this.first_name = "";
        this.last_name = "";
        this.phone = "";
        this.email = "";
        this.purchase_channel = "";
        this.country = "";
        this.province = "";
        this.city = "";
        this.address = "";
        this.zip = "";
        this.shipTried = false;
        this.submitBusy = false;
        this.submitErr = "";
        this.lastOrder = null;
        this.pending = null;
        this.type = "single";
        this.step = "type";
      },
    };
  }

  function mount(root) {
    if (!root || !window.Alpine || root._x_dataStack) return;
    if (!window.__saRxData) {
      window.__saRxData = true;
      window.Alpine.data("saRxApp", saRxFactory);
    }
    window.Alpine.initTree(root);
  }

  if (!window.__saRxBoot) {
    window.__saRxBoot = true;
    document.addEventListener("alpine:init", () => {
      window.__saRxData = true;
      window.Alpine.data("saRxApp", saRxFactory);
    });
    document.addEventListener("shopify:section:load", (event) => {
      const root = event.target && event.target.querySelector ? event.target.querySelector("[data-sa-rx]") : null;
      mount(root);
    });
  }

  if (window.Alpine) {
    document.querySelectorAll("[data-sa-rx]").forEach(mount);
  }
})();
